// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.77923 1H6.71559L9.21559 8.33333H14.7844L17.2844 1H19.2207L23.6748 14.3621L12 23.2572L0.325195 14.3621L4.77923 1Z"}}]};

const LogoGitlabFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-gitlab-filled',
    ref,
    icon: element,
  },
));

LogoGitlabFilledIcon.displayName = 'LogoGitlabFilledIcon';

export default LogoGitlabFilledIcon;
